import Vue from 'vue'
import Router from 'vue-router'
import orderDetail from '@/pages/order/orderDetail'
import weixinAccessIn from '@/components/weixinAccessIn'
import error from '@/components/error'
import myOrderList from '@/pages/order/MyOrderList'
import ApplyTryPage from '@/pages/user/ApplyTryPage'
import QueryCustomsStatus from '@/pages/tools/QueryCustomsStatus'
import ApplyTryPageEsmart from '@/pages/user/ApplyTryPageEsmart'
import ApplyTryPageGSCMS from '@/pages/user/ApplyTryPageGSCMS'
import productPage from '@/pages/user/productPage'
import SignUpCityPartner from '@/pages/user/SignUpCityPartner'
import CustomerComplain from '@/pages/user/CustomerComplain'
import CustomerComplainDetail from '@/pages/user/CustomerComplainDetail'

import BlankSailingList from '@/pages/blanksailing/BlankSailingList'
import BlankSailingSearchPage from '@/pages/blanksailing/BlankSailingSearchPage'

import WmsIndex from '../pages/wms/WmsIndex'
import StockInConfirm from '../pages/wms/stockin/StockInConfirm'
import StockInPlanConfirm from '../pages/wms/stockin/StockInPlanConfirm'
import StockInRecordDetail from '../pages/wms/stockin/StockInRecordDetail'
import StockInPlanList from '../pages/wms/stockin/StockInPlanList'
import StockInConfirmPlanList from '../pages/wms/stockin/StockInConfirmPlanList'

import StockOutConfirm from '../pages/wms/stockout/StockOutConfirm'
import StockOutPlanConfirm from '../pages/wms/stockout/StockOutPlanConfirm'
import StockOutRecordDetail from '../pages/wms/stockout/StockOutRecordDetail'
import StockOutPlanList from '../pages/wms/stockout/StockOutPlanList'
import StockOutConfirmPlanList from '../pages/wms/stockout/StockOutConfirmPlanList'

import SelectType from '../pages/lottery/SelectType'
import Info from '../pages/lottery/Info'
import Lottery from '../pages/lottery/Lottery'
import Result from '../pages/lottery/Result'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/wx/accessin/:platcode',
      name: 'weixinAccessIn',
      component: weixinAccessIn,
      meta: {title: '微信登录授权'}
    },
    {
      path: '/wx/exception/error',
      name: 'error',
      component: error,
      meta: {title: '错误提示'}
    },
    {
      path: '/wx/order/orderdetail',
      name: 'orderDetail',
      component: orderDetail,
      meta: {title: '订单信息'}
    },
    {
      path: '/wx/order/myOrderList',
      name: 'myOrderList',
      component: myOrderList,
      meta: {title: '我的订单'}
    },
    {
      path: '/wx/user/applyTryPage',
      name: 'applyTryPage',
      component: ApplyTryPage,
      meta: {title: '申请免费试用'}
    },
    {
      path: '/wx/tools/qryCustStatus',
      name: 'queryCustomsStatus',
      component: QueryCustomsStatus,
      meta: {title: '订单动态查询'}
    },
    {
      path: '/wx/user/applyTryPageEsmart',
      name: 'applyTryPageEsmart',
      component: ApplyTryPageEsmart,
      meta: {title: '申请免费试用'}
    },
    {
      path: '/wx/user/applyTryPageGSCMS',
      name: 'applyTryPageGSCMS',
      component: ApplyTryPageGSCMS,
      meta: {title: '申请免费试用'}
    },
    {
      path: '/wx/user/productPage',
      name: 'productPage',
      component: productPage,
      meta: {title: '产品介绍'}
    },
    {
      path: '/wx/user/signUpCityPartner',
      name: 'signUpCityPartner',
      component: SignUpCityPartner,
      meta: {title: '城市合伙人报名表'}
    },
    {
      path: '/wx/user/customerComplain',
      name: 'customerComplain',
      component: CustomerComplain,
      meta: {title: '客诉统计'}
    },
    {
      path: '/wx/ks/:code',
      name: 'CustomerComplainDetail',
      component: CustomerComplainDetail,
      meta: {title: '客诉信息'}
    },
    {
      path: '/wx/blanksailing/blankSailingList',
      name: 'blankSailingList',
      component: BlankSailingList,
      meta: {title: '船东停航信息查询'}
    },
    {
      path: '/wx/blanksailing/blankSailingSearchPage',
      name: 'blankSailingSearchPage',
      component: BlankSailingSearchPage,
      meta: {title: '船东停航信息查询'}
    },

    // 仓库
    {
      path: '/wx/wms/wmsIndex',
      name: 'wmsIndex',
      component: WmsIndex,
      meta: {title: '首页'}
    },

    {
      path: '/wx/wms/stockInConfirm',
      name: 'stockInConfirm',
      component: StockInConfirm,
      meta: {title: '入库确认'}
    },

    {
      path: '/wx/wms/stockInRecordDetail',
      name: 'stockInRecordDetail',
      component: StockInRecordDetail,
      meta: {title: '入库完成确认'}
    },

    {
      path: '/wx/wms/stockInPlanConfirm',
      name: 'stockInPlanConfirm',
      component: StockInPlanConfirm,
      meta: {title: '入库计划确认'}
    },

    {
      path: '/wx/wms/stockOutPlanConfirm',
      name: 'stockOutPlanConfirm',
      component: StockOutPlanConfirm,
      meta: {title: '出库计划确认'}
    },

    {
      path: '/wx/wms/stockInPlanList',
      name: 'stockInPlanList',
      component: StockInPlanList,
      meta: {title: '待确认入库计划列表'}
    },

    {
      path: '/wx/wms/StockInConfirmPlanList',
      name: 'stockInConfirmPlanList',
      component: StockInConfirmPlanList,
      meta: {title: '已确认入库计划列表'}
    },

    {
      path: '/wx/wms/StockOutConfirmPlanList',
      name: 'stockOutConfirmPlanList',
      component: StockOutConfirmPlanList,
      meta: {title: '已确认出库计划列表'}
    },

    {
      path: '/wx/wms/stockOutConfirm',
      name: 'stockOutConfirm',
      component: StockOutConfirm,
      meta: {title: '出库确认'}
    },

    {
      path: '/wx/wms/stockOutRecordDetail',
      name: 'stockOutRecordDetail',
      component: StockOutRecordDetail,
      meta: {title: '出库完成确认'}
    },

    {
      path: '/wx/wms/stockOutPlanList',
      name: 'stockOutPlanList',
      component: StockOutPlanList,
      meta: {title: '待出库计划列表'}
    },

    {
      path: '/wx/lottery/selecttype',
      name: 'SelectType',
      component: SelectType,
      meta: {title: '中合供应链 · 青岛物博会'}
    },

    {
      path: '/wx/lottery/info',
      name: 'Info',
      component: Info,
      meta: {title: '中合供应链 · 青岛物博会'}
    },

    {
      path: '/wx/lottery/lottery',
      name: 'Lottery',
      component: Lottery,
      meta: {title: '中合供应链 · 青岛物博会'}
    },

    {
      path: '/wx/lottery/result',
      name: 'Result',
      component: Result,
      meta: {title: '中合供应链 · 青岛物博会'}
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js